
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVerifiedSkillCourseCertificateByProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Certificates_ProductType"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Certificate"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMyCertificateByProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"productType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productType"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VerifiedSkillCourseCertificate_Certificate"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VerifiedSkillCourseCertificate_CourseCertificateValidation"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VerifiedSkillCourseCertificate_SpecializationCertificateValidation"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VerifiedSkillCourseCertificate_Certificate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Certificates_Certificate"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VerifiedSkillCourseCertificate_CourseCertificateValidation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Certificates_CourseCertificateValidation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isPassed"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VerifiedSkillCourseCertificate_SpecializationCertificateValidation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Certificates_SpecializationCertificateValidation"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":905}};
    doc.loc.source = {"body":"# Minimal selection for isVerifiedSkillCourseCompleted (course completion / pass only).\nquery GetVerifiedSkillCourseCertificateByProduct($productItemId: ID!, $productType: Certificates_ProductType!) {\n  Certificate {\n    getMyCertificateByProduct(productItemId: $productItemId, productType: $productType) {\n      ...VerifiedSkillCourseCertificate_Certificate\n      ...VerifiedSkillCourseCertificate_CourseCertificateValidation\n      ...VerifiedSkillCourseCertificate_SpecializationCertificateValidation\n    }\n  }\n}\n\nfragment VerifiedSkillCourseCertificate_Certificate on Certificates_Certificate {\n  product {\n    __typename\n  }\n}\n\nfragment VerifiedSkillCourseCertificate_CourseCertificateValidation on Certificates_CourseCertificateValidation {\n  isPassed\n}\n\nfragment VerifiedSkillCourseCertificate_SpecializationCertificateValidation on Certificates_SpecializationCertificateValidation {\n  __typename\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetVerifiedSkillCourseCertificateByProduct"] = oneQuery(doc, "GetVerifiedSkillCourseCertificateByProduct");
        
        module.exports["VerifiedSkillCourseCertificate_Certificate"] = oneQuery(doc, "VerifiedSkillCourseCertificate_Certificate");
        
        module.exports["VerifiedSkillCourseCertificate_CourseCertificateValidation"] = oneQuery(doc, "VerifiedSkillCourseCertificate_CourseCertificateValidation");
        
        module.exports["VerifiedSkillCourseCertificate_SpecializationCertificateValidation"] = oneQuery(doc, "VerifiedSkillCourseCertificate_SpecializationCertificateValidation");
        
